"use client";
import { useTranslations } from "next-intl";
import FAQSection from "@/components/shared/faq-section";

const ServicesFaq = () => {
  const t = useTranslations("services");
  const items = [0, 1, 2, 3].map((i) => ({
    question: t(`faq.items.${i}.question`),
    answer: t(`faq.items.${i}.answer`),
  }));

  return <FAQSection title={t("faq.sectionTitle")} items={items} />;
};

export default ServicesFaq;
